import React, { useEffect, useState } from 'react';
import CrudTable from '../../components/common/CrudTable';
import { trainerAPI, achievementAPI } from '../../api/services';

const TrainersAdmin = () => {
  const [achievements, setAchievements] = useState([]);

  useEffect(() => {
    achievementAPI.getAll().then(res => setAchievements(res.data?.data || [])).catch(() => {});
  }, []);

  const COLUMNS = [
    { key: 'fullName', label: 'Name' },
    { key: 'position', label: 'Position' },
    { key: 'age', label: 'Age' },
    { key: 'phone', label: 'Phone' },
    { key: 'mediaUrl', label: 'Photo', render: (item) => item.mediaUrl ? <img src={item.mediaUrl} alt="" style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: '50%' }} /> : '—' },
  ];

  const FORM_FIELDS = [
    { name: 'fullName', label: 'Full Name', placeholder: 'Alisher Karimov' },
    { name: 'position', label: 'Position', placeholder: 'Boxing Coach' },
    { name: 'age', label: 'Age', type: 'number', placeholder: '30' },
    { name: 'phone', label: 'Phone', placeholder: '+998901234567' },
    { name: 'instagramLink', label: 'Instagram Link', placeholder: 'https://instagram.com/...' },
    { name: 'telegramLink', label: 'Telegram Link', placeholder: 'https://t.me/...' },
    { 
      name: 'achievementId', 
      label: 'Main Achievement', 
      type: 'select', 
      options: achievements.map(a => ({ label: a.name, value: a.id })) 
    },
    { name: 'mediaId', label: 'Trainer Photo', type: 'file' },
  ];

  return (
    <CrudTable
      title="Trainers"
      entityName="Trainer"
      columns={COLUMNS}
      formFields={FORM_FIELDS}
      fetchData={async () => {
        const res = await trainerAPI.getAll();
        return res.data?.data || [];
      }}
      onAdd={(data) => trainerAPI.add(data)}
      onUpdate={(id, data) => trainerAPI.update(id, data)}
      onDelete={(id) => trainerAPI.delete(id)}
    />
  );
};

export default TrainersAdmin;
